import { render, staticRenderFns } from "./VsiGerki.vue?vue&type=template&id=2b612d29&"
import script from "./VsiGerki.vue?vue&type=script&lang=js&"
export * from "./VsiGerki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports